var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((Object.keys(_vm.availableStatuses[_vm.statusKey])),function(key){return _c('span',{key:`case-status-badge-${key}`,staticClass:"badge rounded-pill me-1 mb-1 text-uppercase",class:_vm.statusClass(key)},[_vm._v(" "+_vm._s(key.split("_").join(" "))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }